import React from 'react';
import { useDispatch } from 'react-redux';
import { actions } from '@/store/store.js';
import Button from "~/components/Button.jsx";

const fn = ()=>{};

const PromptSetForm = ({ promptSetId, prompts, beforeSubmit=fn, afterSubmit=fn, responderType }) => {
    const dispatch = useDispatch();

    const handleSubmit = (event) => {
        event.preventDefault();
        beforeSubmit(event);
        const formData = new FormData(event.target);
        const responsesByPromptId = Object.fromEntries(formData.entries());
        const promptSetSubmission = {
            prompt_set_id: promptSetId,
            responder_type: responderType,
            prompt_responses_attributes: Object.entries(responsesByPromptId).map(([prompt_id, response]) => ({
                prompt_id,
                response
            }))
        }
        dispatch(actions.promptSetSubmissions.create({ promptSetSubmission })).then(() => afterSubmit(event));
    };

    return (
        <form onSubmit={handleSubmit}>
            {prompts.map((prompt, index) => {
                switch (prompt.response_type) {
                    case 'any-of':
                        return (
                            <div className="mb-5" key={prompt.id}>
                                <p className="prompt-prompt">{index+1}. <span className="prompt-text" dangerouslySetInnerHTML={{ __html: prompt.prompt_html }}></span></p>
                                {prompt.options.map((option) => (
                                    <div className="form-check" key={option}>
                                        <input className="form-check-input" type="checkbox" value={option} name={prompt.id} id={prompt.id} required/>
                                        <label className="form-check-label" htmlFor="defaultCheck1">
                                            {option}
                                        </label>
                                    </div>
                                ))}
                            </div>
                        );
                    case 'one-of':
                        return (
                            <div className="mb-5" key={prompt.id}>
                                <p className="prompt-prompt">{index+1}. <span className="prompt-text" dangerouslySetInnerHTML={{ __html: prompt.prompt_html }}></span></p>
                                {prompt.options.map((option) => (
                                    <div className="form-check" key={option}>
                                        <input className="form-check-input" type="radio" name={prompt.id} id={`input-${prompt.id}`} value={option} required/>
                                        <label className="form-check-label" htmlFor={prompt.id}>
                                            {option}
                                        </label>
                                    </div>
                                ))}
                            </div>
                        );
                    case 'text':
                        return (
                            <div className="mb-5" key={prompt.id}>
                                <label htmlFor={`input-${prompt.id}`} className="form-label prompt-prompt">{index+1}. <span className="prompt-text" dangerouslySetInnerHTML={{ __html: prompt.prompt_html }}></span></label>
                                <textarea className="form-control" name={prompt.id} id={`input-${prompt.id}`} rows="3" required></textarea>
                            </div>
                        );
                }
            })}

            <Button type="submit" className="btn site-btn">Submit Assessment</Button>
        </form>
    );
};

export default PromptSetForm;
